__turbopack_context__.v({
  "input": "_234gHG_input",
  "searchInput": "_234gHG_searchInput",
});
